"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsClient = void 0;
/**
 * Used to know if the code is running on the client side or not (usefull to avoid Next hydration issue)
 */
const react_1 = require("react");
const useIsClient = () => {
    const [isClient, setIsClient] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setIsClient(true);
    }, []);
    return isClient;
};
exports.useIsClient = useIsClient;
//# sourceMappingURL=index.js.map